import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmModalComponent } from '@shared/component/confirm-modal/confirm-modal.component';
import { ConfirmModalData } from '@shared/component/confirm-modal/confirm-modal.utils';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ConfirmService implements OnDestroy {
	private readonly destroy: Subject<void> = new Subject();

	constructor(private readonly modal: MatDialog) {}

	public ngOnDestroy(): void {
		this.destroy.next();
		this.destroy.complete();
	}

	public openModal(data: ConfirmModalData): MatDialogRef<ConfirmModalComponent> {
		const dialogRef = this.modal.open(ConfirmModalComponent, {
			panelClass: 'confirm-modal',
			hasBackdrop: true,
			disableClose: true,
			width: '410px',
			data,
		});
		return dialogRef;
	}
}
